import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsSignedIn = createSelector(selectAuthState, (s) => s.isSignedIn);
export const selectUser = createSelector(selectAuthState, (s) => s.user);
export const selectInstallState = createSelector(selectAuthState, (s) => s.installState);
export const selectSelectedAccount = createSelector(selectAuthState, (s) => s.selectedAccount);
export const selectIsAccountManager = createSelector(selectAuthState, (s) => s.selectedAccount?.isAccountManager ?? false);
export const selectInstallStateForProduct = (productId: string) =>
  createSelector(selectInstallState, (state) => state[productId] ?? 'not_installed');

export const selectAccessToken = createSelector(selectAuthState, (s) => s.accessToken);
export const selectIdToken = createSelector(selectAuthState, (s) => s.idToken);
export const selectRefreshToken = createSelector(selectAuthState, (s) => s.refreshToken);
export const selectTokenExpiresAt = createSelector(selectAuthState, (s) => s.tokenExpiresAt);

export const selectContractsByAccount = createSelector(selectAuthState, (s) => s.contractsByAccount);
export const selectSelectedContractId = createSelector(selectAuthState, (s) => s.selectedContractId);
export const selectContractsForSelectedAccount = createSelector(
  selectSelectedAccount,
  selectContractsByAccount,
  (account, contractsByAccount) => account ? (contractsByAccount[account.billingCrmAccountId] ?? []) : [],
);
